var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zagl_1" }, [
    _vm._v("Заявки"),
    _vm.count > 0
      ? _c("span", { staticClass: "oc-super" }, [_vm._v(_vm._s(_vm.count))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "a",
      {
        attrs: {
          href: "#",
          "data-toggle": "modal",
          "data-target": "#settingsModal",
          title: "Настройки"
        },
        on: {
          click: function($event) {
            return _vm.$emit("settingsClick")
          }
        }
      },
      [_c("i", { staticClass: "oc-icon16 ico-cog" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a321ae5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a321ae5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/Title.vue
// module id = 158
// module chunks = 1